import { render, staticRenderFns } from "./ChangLianOrderList.vue?vue&type=template&id=ca5c2174&scoped=true"
import script from "./ChangLianOrderList.vue?vue&type=script&lang=js"
export * from "./ChangLianOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5c2174",
  null
  
)

export default component.exports